require('./angular-route');
module.exports = 'ngRoute';



//////////////////
// WEBPACK FOOTER
// ../~/angular-route/index.js
// module id = 3
// module chunks = 0